// Asset and API base paths
const ASSETS_PATH = "https://assets.stylori.com";
const BASE_API_URL = "https://api.stylori.com";
// const BASE_API_URL = "http://lcalhost:8002";
const GRAPHQL_API_URL = `${BASE_API_URL}/graphql`;

// Default Image Path
const DEFAULT_IMAGE_PATH = `${ASSETS_PATH}/assets/images/default_image.jpg`;
const CVD_IMAGE_CDN = "https://ddccewlid70xs.cloudfront.net/";
const DOMAIN_URLS = [
  "stylori.com",
  "https://stylori.com"
];
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SITE_PATHS: DOMAIN_URLS,
  DEFAULT_NO_PRODUCT_IMAGE: DEFAULT_IMAGE_PATH,
  DEFAULT_IMAGE: `${ASSETS_PATH}/assets/images`,
  CVD_IMAGE_CDN: CVD_IMAGE_CDN,
  ADDITIONAL_PATH: "/styloriSilver",
  CLEAR_FILTER_REDIRECT_PATH: "/silver-jewellery?sort=New to Stylori",
  image_url: ASSETS_PATH + "/",
  cvd_image_url: CVD_IMAGE_CDN,
  api_url: BASE_API_URL,
  api_url_graphql: GRAPHQL_API_URL,
  shipping_days: 7, // shipping days intervals...
  HomePageBanner: "HomePageBanner",
  StyloriCard: "StyloriCard",
  StyloriTitle: "StyloriTitle",
  BestSellers: "BESTSELLERS",
  StyloriCardPrice: "StyloriCardPrice",
  ProductDescription:"productdescription",
  ProductList:"productlist",
  ShopbyFinish_title:"11",  
  ShopbyFinish_data:"12",
  bestSeller_title:"5",  
  bestSeller_data:"6",
  ShopbyFinish: "SHOPBYFINISH",
  testimonial: "TestimonialSlider",
  BlogPageCard: "blogPageCard",
  PersonalInformation: "Personal Information",
  ManageAddress: "Manage Address",
  Wishlist: "Wishlist",
  AllOrders: "All Orders",
  RedeemPoints: "Redeem Points",
  SingleOrder: "View Orders",
  ShoppingBag: "Shopping Bag",
  Logout: "Logout",
  MobileNumber: "Mobile Number",
  EmailAddress: "Email Address",
  Password: "Password",
  AddressEdit: "AddressEdit",
  AddressDelete: "AddressDelete",
  Confirmation: "Confirmation",
  RemoveWishlist: "Remove Wishlist",
  imageCurrency:
    "https://raw.githubusercontent.com/madebybowtie/FlagKit/master/Assets/PNG/",
  Signin: "signin",
  SigninOtp: "signinotp",
  Register: "register",
  Login: "login",
  Reset: "reset",
  Resetpassword: "resetpassword",
  Subscribe: "subscribe",
  Forgot: "forgot",
  SilverSitemap: "silver-sitemap",
  Careers: "careers",
  Account_Wishlist: "account-wishlist",
  Account_Profile: "account-profile",
  FaqTitle: "faqTitle",
  FaqComponents: "faqComponents",
  BestSeller: "best seller",
  Account_Addresses: "account-addresses",
  Account_Allorders: "account-allorders",
  Account_Redeempoints: "account-redeempoints",
  InstagramPost: "InstagramPost",
  Starspotting: "STARSPOTTING",
  INR: "INR",
  CDN_HOME:19,
  vow:[
    {
    id:1,
      text1:"Muhurtham Collection",
    text2:"Eternal moment",
    text3:"Timed to tradition",
    text4:"",
    text5:"",
    image:"/vow1.jpg",
    url:"/silver-muhurtham-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
  },
  {
    id:2,
    text1:"Haldi Collection",
    text2:"Vibrance Unfolded",
    text3:"Celebrate Every Shade",
    text4:"",
    text5:"",
    image:"/vow2.jpg",
    url:"/silver-haldi-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
  },
  {
    id:3,
    text1:"Sangeet Collection",
    text2:"Dazzle",
    text4:"Night",
    image:"/vow3.jpg",
    text3:"Sparkle",
    text5:"in Sync",
    url:"/silver-sangeet+mehandi-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
  },
  {
    id:4,
    text1:"Reception Collection",
    text2:"Evening Whisper",
    text3:"Wear the wonder",
    text4:"",
    text5:"",
    image:"/vow4.jpg",
    url:"/silver-reception-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0"
  }
]
};
